import { dispatcher, Container, SpineBase, ingenuity, delayedCall, killDelayedCall } from "@quest/base-core";
import { JackpotBannerView } from "./JackpotBannerView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { IObject } from "@quest/adapter-interface";
import { GameParserModel } from "../Platform/GameParserModel";
import { SlotEventConstants } from "@quest/slot-core/dist/SlotConstants/SlotEventDispatchers";
import { ButtonBaseBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-leopard/dist";
import { gameConstants } from "../Constants/gameConstants";
import { Emitter } from "@quest/pixi-bridge";
import { SlotConstants } from "@quest/slot-core";
import { MeterBitmapGame } from "../UI/MeterBitmapGame";
import { SoundConstantGame } from "../Constants/SoundConstantGame";



export class JackpotBannerController {
    private emitter: Emitter;
    private miniWinContentContainer: Container;
    private minorWinContentContainer: Container;
    private majorWinContentContainer: Container;


    private grandJpEmitter: Emitter;
    private grandJpEmitter2: Emitter;

    private view: JackpotBannerView;
    private startIndex: number = 0;
    private jackpotTickup: number = 0;

    private sortedJackpot: IObject;

    private JACKPOT_GRAND_STR: string = "jackpot_grand";
    private jackpotMultiplier: number;
    private continueButtonMini: ButtonBaseBehavior;
    private continueButtonMinor: ButtonBaseBehavior;
    private continueButtonMajor: ButtonBaseBehavior;
    private continueButtonGrand: ButtonBaseBehavior;


    constructor(view: JackpotBannerView) {
        this.view = view;
        this.view.visible = true;
        this.subscribeEvent();
        this.initializeElements();
        this.bindHandlers();
    }


    /**
  * Initialize Data for Coin Shower Emmiter
  */
    private initializeCoinShowerEmitter(): void {
        const particleData: any = {
            emitterType: 1,
            id: "winCoinEmitter",
            autoStart: false,
            animConfig: [
                {
                    framerate: 20,
                    loop: true,
                    image: "Coin_rotation",
                    generateFrames: true,
                    frames: [0, 14],
                },
            ],
        };
        const config = {
            alpha: {
                start: 0.5,
                end: 1,
            },
            scale: {
                start: 0.8,
                end: 1,
                minimumScaleMultiplier: 0.5,
            },
            speed: {
                start: 500,
                end: 500,
                minimumSpeedMultiplier: 2,
            },
            acceleration: {
                x: 0,
                y: 200,
            },
            maxSpeed: 0,
            startRotation: {
                min: 0,
                max: 360,
            },
            noRotation: true,
            rotationSpeed: {
                min: 0,
                max: 10,
            },
            lifetime: {
                min: 4,
                max: 4,
            },
            blendMode: "normal",
            frequency: 0.035,
            emitterLifetime: -1,
            maxParticles: 60,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "point"
        };
        const coinShowerContainer: Container = this.view.triggeredJackpotContainer.children[0];
        coinShowerContainer.mask = this.view.coinShowerContainerMask;
        ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as Emitter;
    }
    /**
   * Method to start the emitter
   * @returns
   */
    private startCoinShowerEmitter(): void {
        this.emitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter");
        this.emitter.autoUpdate = true;
        this.emitter.emit = true;
    }


 /**
  * Method initializeGrandJPEmitter initialize grand JP emitters
  */
    private initializeGrandJPEmitter(): void {
        const particleData: any = {
            emitterType: 1,
            id: "winCoinEmitter1",
            autoStart: false,
            animConfig: [
                {
                    framerate: 20,
                    loop: true,
                    image: "Coin_rotation",
                    generateFrames: true,
                    frames: [0, 14],
                },
            ],
        };
        const config = {
            alpha: {
                start: 1,
                end: 1,
            },
            scale: {
                start: 1,
                end: 0.5,
                minimumScaleMultiplier: 0.5,
            },
            speed: {
                start: 300,
                end: 300,
                minimumSpeedMultiplier: 2,
            },
            acceleration: {
                x: 0,
                y: 200,
            },
            maxSpeed: 0,
            startRotation: {
                min: 0,
                max: -190,
            },
            noRotation: true,
            rotationSpeed: {
                min: 0,
                max: 10,
            },
            lifetime: {
                min: 4,
                max: 1,
            },
            blendMode: "normal",
            frequency: 0.016,
            emitterLifetime: -1,
            maxParticles: 60,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "point"
        };
        const coinShowerContainer: Container = this.view.triggeredJackpotContainer.children[0];
        coinShowerContainer.mask = this.view.coinShowerContainerMask;
        ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as any;
    }

    /**
  * Method startGrandJPEmitter start grand JP emitters
  */
    private startGrandJPEmitter(): void {
        this.grandJpEmitter = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter1");
        this.grandJpEmitter.autoUpdate = true;
        this.grandJpEmitter.emit = true;
    }

     /**
  * Method initializeGrandJPEmitter2 initialize second type of emitters during grand JP
  */
    private initializeGrandJPEmitter2(): void {
        const particleData: any = {
            emitterType: 1,
            id: "winCoinEmitter2",
            autoStart: false,
            animConfig: [
                {
                    framerate: 15,
                    loop: true,
                    image: "Coin_rotation",
                    generateFrames: true,
                    frames: [0, 14],
                },
            ],
        };
        const config = {
            alpha: {
                start: 1,
                end: 1,
            },
            scale: {
                start: 1,
                end: 0.5,
                minimumScaleMultiplier: 0.5,
            },
            speed: {
                start: 1000,
                end: 1000,
                minimumSpeedMultiplier: 2,
            },
            acceleration: {
                x: 0,
                y: 4000,
            },
            maxSpeed: 0,
            startRotation: {
                min: 0,
                max: -190,
            },
            noRotation: false,
            rotationSpeed: {
                min: 0,
                max: 10,
            },
            lifetime: {
                min: 10,
                max: 10,
            },
            blendMode: "normal",
            frequency: 0.001,
            emitterLifetime: 1,
            maxParticles: 60,
            pos: {
                x: 0,
                y: 0,
            },
            addAtBack: false,
            spawnType: "point"
        };
        const coinShowerContainer: Container = this.view.triggeredJackpotContainer.children[2];
        coinShowerContainer.mask = this.view.coinShowerContainerMask;
        ingenuity.currentGame.add.emitter(coinShowerContainer, particleData, config) as any;
    }

    /**
  * Method startGrandJPEmitter2 start second type of emitters during grand JP
  */
    private startGrandJPEmitter2(): void {
        this.grandJpEmitter2 = ingenuity.currentGame.particles.getEmitterById("winCoinEmitter2");
        this.grandJpEmitter2.autoUpdate = true;
        this.grandJpEmitter2.emit = true;
    }

     /**
  * Method startGrandJackpotEmitter to start second type of emitters during grand JP
  */
    private startGrandJackpotEmitter(): void {
        this.initializeGrandJPEmitter2();
        this.startGrandJPEmitter2();
    }

    /**
  * Method subscribeEvent to subscribe events
  */
    private subscribeEvent(): void {
        dispatcher.on(eventDispatchers.SHOW_JACKPOT_BANNER, this.playJackpotBanner, this);
    }

    /**
     * Initialize all elements
     */
    private initializeElements(): void {
        this.miniWinContentContainer = this.view.getContainerByID("miniWinContentContainer");
        this.minorWinContentContainer = this.view.getContainerByID("minorWinContentContainer");
        this.majorWinContentContainer = this.view.getContainerByID("majorWinContentContainer");
        this.continueButtonGrand = this.view.getButtonById("continueButton_grand") as ButtonBaseBehavior;
        this.continueButtonMajor = this.view.getButtonById("continueButton_major") as ButtonBaseBehavior;
        this.continueButtonMinor = this.view.getButtonById("continueButton_minor") as ButtonBaseBehavior;
        this.continueButtonMini = this.view.getButtonById("continueButton_mini") as ButtonBaseBehavior;
        this.disableJackpotButtons();
    }

    private disableJackpotButtons():void{
        this.continueButtonGrand.visible = false;
        this.continueButtonMajor.visible = false;
        this.continueButtonMini.visible = false;
        this.continueButtonMinor.visible = false;
    }

    /**to bind button handlers */
    private bindHandlers(): void{
        this.unbindHandlers();
        this.continueButtonGrand.on(ButtonBaseBehavior.UP, this.onGrandContinuePressUP, this);
        this.continueButtonMajor.on(ButtonBaseBehavior.UP, this.onMajorContinuePressUP, this);
        this.continueButtonMinor.on(ButtonBaseBehavior.UP, this.onMinorContinuePressUP, this);
        this.continueButtonMini.on(ButtonBaseBehavior.UP, this.onMiniContinuePressUP, this);
    }

    /**to unbind button handlers */
    private unbindHandlers(): void{
        this.disableJackpotButtons();
        this.continueButtonGrand.off(ButtonBaseBehavior.UP, this.onGrandContinuePressUP, this);
        this.continueButtonMajor.off(ButtonBaseBehavior.UP, this.onMajorContinuePressUP, this);
        this.continueButtonMinor.off(ButtonBaseBehavior.UP, this.onMinorContinuePressUP, this);
        this.continueButtonMini.off(ButtonBaseBehavior.UP, this.onMiniContinuePressUP, this);
    }

    /**to handle Grand Continue button pressup */
    private onGrandContinuePressUP(): void{
        const jackpotName: string = "grand";
        const jackpotContainer: Container = this.view.getContainerByID("taptoclickMessage_"+ jackpotName) as Container;
        const jackpotButton: ButtonBaseBehavior = this.view.getButtonById("continueButton_"+ jackpotName) as ButtonBaseBehavior;        const multiplier: MeterBitmapGame = this.view.getMeterById("multiplier_" + jackpotName) as MeterBitmapGame
        const jackpotWinTickup: MeterBitmapGame = this.view.getMeterById("winMeter_" + jackpotName) as MeterBitmapGame;
        const meterContainer: Container = this.view.getContainerByID("winMeterContainer_" + jackpotName);
        this.stopJPSpine(jackpotName);
        jackpotContainer.visible = false;
        jackpotButton.visible = false;
        meterContainer.visible = false;
        multiplier.visible = false;
        jackpotWinTickup.resetMeter();
        ingenuity.currentGame.ticker.remove(this.setJackpotPanelPivot, this);
    }

    /**to handle Major Continue button pressup */
    private onMajorContinuePressUP(): void{
        const jackpotName: string = "major";
        const jackpotContainer: Container = this.view.getContainerByID("taptoclickMessage_"+ jackpotName) as Container;
        const jackpotButton: ButtonBaseBehavior = this.view.getButtonById("continueButton_"+ jackpotName) as ButtonBaseBehavior;        const multiplier: MeterBitmapGame = this.view.getMeterById("multiplier_" + jackpotName) as MeterBitmapGame
        const jackpotWinTickup: MeterBitmapGame = this.view.getMeterById("winMeter_" + jackpotName) as MeterBitmapGame;
        const meterContainer: Container = this.view.getContainerByID("winMeterContainer_" + jackpotName);
        this.stopJPSpine(jackpotName);
        jackpotButton.visible = false;
        jackpotContainer.visible = false;
        meterContainer.visible = false;
        multiplier.visible = false;
        jackpotWinTickup.resetMeter();
        ingenuity.currentGame.ticker.remove(this.setJackpotPanelPivot, this);
    }

    /**to handle Minor Continue button pressup */
    private onMinorContinuePressUP(): void{
        const jackpotName: string = "minor";
        const jackpotContainer: Container = this.view.getContainerByID("taptoclickMessage_"+ jackpotName) as Container;
        const jackpotButton: ButtonBaseBehavior = this.view.getButtonById("continueButton_"+ jackpotName) as ButtonBaseBehavior;        const multiplier: MeterBitmapGame = this.view.getMeterById("multiplier_" + jackpotName) as MeterBitmapGame
        const jackpotWinTickup: MeterBitmapGame = this.view.getMeterById("winMeter_" + jackpotName) as MeterBitmapGame;
        const meterContainer: Container = this.view.getContainerByID("winMeterContainer_" + jackpotName);
        this.stopJPSpine(jackpotName);
        jackpotButton.visible = false;
        jackpotContainer.visible = false;
        meterContainer.visible = false;
        multiplier.visible = false;
        jackpotWinTickup.resetMeter();
        ingenuity.currentGame.ticker.remove(this.setJackpotPanelPivot, this);
    }

    /**to handle Mini Continue button pressup */
    private onMiniContinuePressUP(): void{
        const jackpotName: string = "mini";
        const jackpotContainer: Container = this.view.getContainerByID("taptoclickMessage_"+ jackpotName) as Container;
        const jackpotButton: ButtonBaseBehavior = this.view.getButtonById("continueButton_"+ jackpotName) as ButtonBaseBehavior;
        const multiplier: MeterBitmapGame = this.view.getMeterById("multiplier_" + jackpotName) as MeterBitmapGame
        const jackpotWinTickup: MeterBitmapGame = this.view.getMeterById("winMeter_" + jackpotName) as MeterBitmapGame;
        const meterContainer: Container = this.view.getContainerByID("winMeterContainer_" + jackpotName);
        this.stopJPSpine(jackpotName);
        jackpotButton.visible = false;
        jackpotContainer.visible = false;
        meterContainer.visible = false;
        multiplier.visible = false;
        jackpotWinTickup.resetMeter();
        ingenuity.currentGame.ticker.remove(this.setJackpotPanelPivot, this);
    }

    /**
     * setJackpotPanelPivot method set pivot for jackpot containers
     */
    private setJackpotPanelPivot(): void {
        this.miniWinContentContainer.setPivot(this.miniWinContentContainer.width / 2, 0);
        this.minorWinContentContainer.setPivot(this.minorWinContentContainer.width / 2, 0);
        this.majorWinContentContainer.setPivot(this.majorWinContentContainer.width / 2, 0);
    }

    /**
  * Method startJackpotCoinShower to start jackpot coin shower
  */
    private startJackpotCoinShower(): void {
        this.initializeCoinShowerEmitter();
        this.startCoinShowerEmitter();
    }


    /**
     * Method to stop coin Emitter.
     */
    private stopCoinEmitter(): void {
        this.emitter && (this.emitter.emit = false);
        this.emitter && (this.emitter.autoUpdate = false);
        this.emitter && this.emitter.destroy();

        this.grandJpEmitter && (this.grandJpEmitter.emit = false);
        this.grandJpEmitter && (this.grandJpEmitter.autoUpdate = false);
        this.grandJpEmitter && this.grandJpEmitter.destroy();

        this.grandJpEmitter2 && (this.grandJpEmitter2.emit = false);
        this.grandJpEmitter2 && (this.grandJpEmitter2.autoUpdate = false);
        this.grandJpEmitter2 && this.grandJpEmitter2.destroy();

        this.view.triggeredJackpotContainer.children[0].removeChildren();
        this.view.triggeredJackpotContainer.children[2] && this.view.triggeredJackpotContainer.children[2].removeChildren()
    }

    /**
  * Method sequenceJackpot to sequence jackpots
  */
    private sequenceJackpot(jackpot: IObject): any {
        const searchKey: string[] = ["mini", "minor", 'major', "grand"];
        let updatedArray: [string, number][] = [];
        for (let j = 0; j < searchKey.length; j++) {
            for (let i = 0; i < jackpot.length; i++) {
                if (searchKey[j] === jackpot[i][0] && jackpot[i][1] > 0) {  //push jackpot whose corresponding multiplier is greater than 0
                    updatedArray.push(jackpot[i]);
                    break; // Exit the loop since the JP key is found
                }
            }
        }
        return updatedArray;
    }

    /**
  * Method playJackpotBanner to play jackpot banners
  */
    private playJackpotBanner(): void {
        const isfreeGame: boolean = (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState);
        let jackpotWon: IObject = isfreeGame ? (ingenuity.parserModel as GameParserModel).getAwardJackpotsFG() : (ingenuity.parserModel as GameParserModel).getJackpotWonBG();
        if (isfreeGame) {
            dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_FG_BUTTON_PANEL_ON_TOP);
            for (const key in jackpotWon) {
                if (key === this.JACKPOT_GRAND_STR && jackpotWon[key] > 0) {
                    jackpotWon = {
                        "grand": jackpotWon[key]
                    }
                }
            }
        }
        else {
            dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
        }

        const jackpot: [string, number][] = Object.entries(jackpotWon);
        this.sortedJackpot = this.sequenceJackpot(jackpot);
        this.showJackpotBannersPresentation();
    }

     /**
  * Method showJackpotBannersPresentation to show jackpot banners animations
  */
    private showJackpotBannersPresentation(): void {
        if (this.startIndex >= this.sortedJackpot.length) {
            this.view.visible = false;
            this.startIndex = 0;
            this.handleJackpot();
        } else {
            this.view.visible = true;
            const jackpotName = this.sortedJackpot[this.startIndex][0];
            this.jackpotMultiplier = this.sortedJackpot[this.startIndex][1]
            const jackpotMulti = this.jackpotMultiplier > 1 ? "withMulti" : "withoutMulti";
            this.getTriggeredJP(jackpotName);
            if (this.sortedJackpot[this.startIndex][0] === 'grand') {
                this.playGrandJackpotPresentation(jackpotName,jackpotMulti)
            } else {
                this.playJackpotPresentation(jackpotName,jackpotMulti)
                
            }
        }
    }

    /**
  * Method handleJackpot to play presentation according to game state
  */
    private handleJackpot():void{
        const isfreeGame: boolean = (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState);
        if (isfreeGame) {
            dispatcher.fireEvent(eventDispatchers.SHOW_OUTRO_AFTER_FG);
        } else {
            if (!(ingenuity.parserModel as GameParserModel).getHasLineWins() && !ingenuity.currentGame.state.getCurrentState().model.getIsBigWin()) {
                dispatcher.fireEvent(SlotEventConstantsBehavior.UPDATE_BOTTOM_BAR_WIN, { value: ingenuity.parserModel.getTotalWin() });
            }
            dispatcher.fireEvent(SlotEventConstants.SHOW_NEXT_WIN_PRESENTATION);
        }
    }

    /**
  * Method playGrandJackpotPresentation to play animation during grand jackpot
  */
    private playGrandJackpotPresentation(jackpotName:string,jackpotMulti:string):void{
        this.view.triggeredJackpotContainer = this.view.getContainerByID(jackpotName + "_" + jackpotMulti);
        this.view.triggeredJackpotBGContainer = this.view.getContainerByID(jackpotName + "_" + jackpotMulti + "_bg");
        //play spine if grand wins with multiplier or without multiplier
        const inAnim:string = jackpotMulti === "withoutMulti" ? "in_grand_base_without_multiplier" : "in_grand_base";
        const loopAnim:string = jackpotMulti === "withoutMulti" ? "loop_grand_base_without_multiplier" : "loop_grand_base";
        this.playGrandBannerAnim(inAnim, loopAnim);
        this.playJackpotBackAnimation();
        this.playJackpotCharAnimation(true,"in_text","loop_text");
    }

     /**
     * Method playJackpotPresentation to play animation during jackpot (other than grand)
     */
    private playJackpotPresentation(jackpotName:string,jackpotMulti:string):void{
        this.view.triggeredJackpotContainer = this.view.getContainerByID(jackpotName + "_" + jackpotMulti);
        this.view.triggeredJackpotBGContainer = this.view.getContainerByID(jackpotName + "_" + jackpotMulti + "_bg");
        this.playJackpotBackAnimation();
        if(jackpotMulti==="withoutMulti"){
            this.playJackpotCharAnimation(false,"in_text_without_multiplier","loop_text_without_multiplier");
        }
        else{
            this.playJackpotCharAnimation(false,"in_text","loop_text");
        }
        this.startJackpotCoinShower();
    }

    /**
  * Method getTriggeredJP to get triggered jackpot
  */
    private getTriggeredJP(name: string): void {
        switch (name) {
            case "mini":
                this.miniJackpot();
                break;
            case "minor":
                this.minorJackpot();
                break;
            case "major":
                this.majorJackpot();
                break;
            case "grand":
                this.grandJackpot();
                break;
        }
    }

    /**
  * Method majorJackpot to show major jackpot functionality
  */
    private majorJackpot(): void {
        (ingenuity.soundManager as any).playSound(SoundConstantGame.JACKPOT_POPUP_MAJOR, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
        dispatcher.fireEvent(eventDispatchers.SHOW_BLUR_BACKGROUND, eventDispatchers.SHOW_MAJOR_BLUR_BG);
        this.jackpotTickup = (ingenuity.parserModel as GameParserModel).getMajorJackpotWonBG();
        dispatcher.fireEvent(eventDispatchers.START_JP_BUTTON_PANEL_TICKUP, this.jackpotTickup);
    }

    /**
  * Method minorJackpot to show minor jackpot functionality
  */
    private minorJackpot(): void {
        (ingenuity.soundManager as any).playSound(SoundConstantGame.JACKPOT_POPUP_MINOR, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
        dispatcher.fireEvent(eventDispatchers.SHOW_BLUR_BACKGROUND, eventDispatchers.SHOW_MINOR_BLUR_BG);
        this.jackpotTickup = (ingenuity.parserModel as GameParserModel).getMinorJackpotWonBG();
        dispatcher.fireEvent(eventDispatchers.START_JP_BUTTON_PANEL_TICKUP, this.jackpotTickup);
    }

    /**
  * Method miniJackpot to show mini jackpot functionality
  */
    private miniJackpot(): void {
        (ingenuity.soundManager as any).playSound(SoundConstantGame.JACKPOT_POPUP_MINI, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
        dispatcher.fireEvent(eventDispatchers.SHOW_BLUR_BACKGROUND, eventDispatchers.SHOW_MINI_BLUR_BG);
        this.jackpotTickup = (ingenuity.parserModel as GameParserModel).getMiniJackpotWonBG();
        dispatcher.fireEvent(eventDispatchers.START_JP_BUTTON_PANEL_TICKUP, this.jackpotTickup)
    }

    /**
  * Method grandJackpot to show grand jackpot functionality
  */
    private grandJackpot(): void {
        (ingenuity.soundManager as any).playSound(SoundConstantGame.JACKPOT_POPUP_GRAND, 1, false, gameConstants.SOUND_LIST_POSTLOAD);
        dispatcher.fireEvent(eventDispatchers.SHOW_BLUR_BACKGROUND, eventDispatchers.SHOW_GRAND_BLUR_BG);
        const isfreeGame: boolean = (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState);
        this.jackpotTickup = isfreeGame ? (ingenuity.parserModel as GameParserModel).getGrandJackpotWinFG() : (ingenuity.parserModel as GameParserModel).getGrandJackpotWonBG();
        dispatcher.fireEvent(eventDispatchers.START_JP_BUTTON_PANEL_TICKUP, this.jackpotTickup);
    }

    /**
  * Method playJackpotBackAnimation to play jackpot background anims
  */
    private playJackpotBackAnimation(): void {
        const JPContainer = this.view.triggeredJackpotBGContainer;
        JPContainer.forEach((anim: SpineBase) => {
            anim.visible = true;
            anim.setPause(false);
            anim.playAnim("in_base", false);
            anim.onComplete.addOnce(() => {
                anim.playAnim("loop_base", true);
            });
        });
    }

 /**
  * Method playJackpotCharAnimation to play character animation
  */
    private playJackpotCharAnimation(isGrand: boolean, inSpine:string, loopSpine:string): void {
        const JPContainer = this.view.triggeredJackpotContainer.children[1];
        JPContainer.children[0].visible = true;
        JPContainer.children[0].playAnim(inSpine, false);
        JPContainer.children[0].onComplete.addOnce(() => {
            JPContainer.children[0].playAnim(loopSpine, true);
            if (!isGrand) {
                this.startjpWinTickup();
            }
        });
        if (!ingenuity.deviceEnv.isDesktop) {
            JPContainer.children[1].visible = true;
            JPContainer.children[1].playAnim(inSpine, false);
            JPContainer.children[1].onComplete.addOnce(() => {
                JPContainer.children[1].playAnim(loopSpine, true);
            });
        }
        this.view.handleAnimationInPola();
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState){
            if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.MUSIC_SPIN, "soundList")) {
                ingenuity.soundManager.getSoundInstance(SoundConstantGame.MUSIC_SPIN, "soundList").volume = 0.3;
            }
        }
    }

    /**
  * Method playGrandBannerAnim to play grand banner animation
  */
    private playGrandBannerAnim(inSpine:string,loopSpine:string): void {
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState){
            dispatcher.fireEvent(SlotEventConstantsBehavior.HIDE_FREESPIN_COUNTER);
            if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD)) {
                (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD).volume = 0.3;
            }
        }
        const JPContainer = this.view.triggeredJackpotContainer.children[3];
        JPContainer.children[0].visible = true;
        JPContainer.children[0].setPause(false);
        JPContainer.children[0].playAnim(inSpine, false);
        delayedCall("TickUpdelayKey", 1000, () => {
            this.startjpWinTickup();
            this.startGrandJackpotEmitter();
        },this)
        JPContainer.children[0].onComplete.addOnce(() => {
            JPContainer.children[0].playAnim(loopSpine, true);
            this.initializeGrandJPEmitter();
            this.startGrandJPEmitter();
            
        });
        if (!ingenuity.deviceEnv.isDesktop) {
            JPContainer.children[1].visible = true;
            JPContainer.children[1].setPause(false);
            JPContainer.children[1].playAnim(inSpine, false);
            JPContainer.children[1].onComplete.addOnce(() => {
                JPContainer.children[1].playAnim(loopSpine, true);
            });
        }
    }

    /**
  * Method startjpWinTickup to start jackpot win tickup
  */
    private startjpWinTickup(): void {
        ingenuity.currentGame.ticker.add(this.setJackpotPanelPivot, this);
        const delayKey: string = "GrandtickupComplete";
        const jackpotName = this.sortedJackpot[this.startIndex][0];
        const multiplier = this.view.getMeterById("multiplier_" + jackpotName) as MeterBitmapGame
        this.handleMultiplier(multiplier);
        let jackpotWinTickup = this.view.getMeterById("winMeter_" + jackpotName) as MeterBitmapGame;
        let meterContainer = this.view.getContainerByID("winMeterContainer_" + jackpotName);
        const jackpotContainer: Container = this.view.getContainerByID("taptoclickMessage_"+ jackpotName) as Container;
        const jackpotButton: ButtonBaseBehavior = this.view.getButtonById("continueButton_"+ jackpotName) as ButtonBaseBehavior;
        meterContainer.visible = true
        let currentVal: number = 0;
        currentVal = this.jackpotTickup;
        jackpotWinTickup.visible = true;
        this.disableJackpotButtons();
        jackpotWinTickup.startTick(currentVal , true, false, 4, true, () => {
            // done to hide continue button during freegame grand jackpot as it is not required.
            if(ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState){
                jackpotButton.visible = true;
                jackpotContainer.visible=true
            }else{
                // to hide grand meter amount with delay
                delayedCall(delayKey, SlotConstantsBehavior.DURATION_700, () => {
                    killDelayedCall(delayKey);
                    this.onGrandContinuePressUP();
                }, this);
            }
        })
    }

    /**
  * Method handleMultiplier to set jackpot multiplier
  */
    private handleMultiplier(multiplier: MeterBitmapGame): void {
        if (this.jackpotMultiplier > 1) {
            multiplier.visible = true;
            multiplier.setText(this.jackpotMultiplier + "X")
        }
    }

    /**
  * Method stopJPSpine to stop emitter, animations, hide blue BGs
  */
    protected stopJPSpine(jackpotName:string): void {
        const jackpotMulti = this.jackpotMultiplier > 1 ? "withMulti" : "withoutMulti";
        this.stopCoinEmitter();
        this.hideBannerAnim(jackpotMulti);
        this.hideCharAnim(jackpotMulti,jackpotName);
        this.hideBackAnim();
        dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BACKGROUND, eventDispatchers.HIDE_GRAND_BLUR_BG);
        dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BACKGROUND, eventDispatchers.HIDE_MAJOR_BLUR_BG);
        dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BACKGROUND, eventDispatchers.HIDE_MINOR_BLUR_BG);
        dispatcher.fireEvent(eventDispatchers.HIDE_BLUR_BACKGROUND, eventDispatchers.HIDE_MINI_BLUR_BG);
    }
    
/**
  * Method hideCharAnim to hide jackpot character animation
  */
    private hideCharAnim(jackpotMulti:string,jackpotName:string): void {
        let outSpine:string = (jackpotName === "grand" || jackpotMulti === "withoutMulti") ? "out_text" : "out_text_multiplier"
        const JPContainer = this.view.triggeredJackpotContainer.children[1];
        JPContainer.children[0].playAnim(outSpine, false);
        JPContainer.children[0].onComplete.addOnce(() => {
            JPContainer.children[0].visible = false;
            this.startIndex++
            this.showJackpotBannersPresentation();
        })
        if (!ingenuity.deviceEnv.isDesktop) {
            JPContainer.children[1].visible = true;
            JPContainer.children[1].playAnim(outSpine, false);
            JPContainer.children[1].onComplete.addOnce(() => {
                JPContainer.children[1].visible = false;
            })
        }
    }

    /**
  * Method hideBackAnim to hide background animation
  */
    private hideBackAnim(): void {
        const JPContainer = this.view.triggeredJackpotBGContainer;
        JPContainer.forEach((anim: SpineBase) => {
            anim.playAnim("out_base", false);
            anim.onComplete.addOnce(() => {
                anim.visible = false;
                anim.setPause(true);
            });
        });
        if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.baseGameState){
            if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.MUSIC_SPIN, "soundList")) {
                ingenuity.soundManager.getSoundInstance(SoundConstantGame.MUSIC_SPIN, "soundList").volume = 1;
            }
        }
    }

    /**
     * Method hideBannerAnim to hide jackpot banner animation
     */
    private hideBannerAnim(jackpotMulti:string): void {
        let grandOutBase:string=jackpotMulti==="withoutMulti"?"out_grand_base_without_multiplier":"out_grand_base";
        const JPContainer = this.view.triggeredJackpotContainer.children[3];
        JPContainer && JPContainer.forEach((anim: SpineBase) => {
            anim.playAnim(grandOutBase, false);
            anim.onComplete.addOnce(() => {
                anim.visible = false;
                anim.setPause(true);
                if (ingenuity.currentGame.state.getCurrentState().key === SlotConstants.freeGameState){
                    if ((ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD)) {
                        (ingenuity.soundManager as any).getSoundInstance(SoundConstantGame.FREE_GAME_BGM, gameConstants.SOUND_LIST_POSTLOAD).volume = 1;
                    }
                }
            });
        });
    }
}